import {inject, Injectable} from '@angular/core';
import {environment} from '../../../../../environment';
import {HttpClient, HttpContext, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import { IProductList} from '../../../shared/model/product.model';
import { IProduct } from '../product-update/product-update.model';
import {SHOW_TOAST} from '../../../login/login.service';

export type EntityArrayResponseType = HttpResponse<IProductList>;
export type EntityResponseType = HttpResponse<IProduct>;

export interface ProductMassiveLoadError {
  rowNumber: number;
  identifier?: string;
  field?: string;
  message: string;
}

export interface ProductMassiveLoadResponse {
  updatedRows: number;
  totalErrors: number;
  errors: ProductMassiveLoadError[];
  technicalError?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private apiProduct = `${environment.wsApiBaseUrl}/api/product`
  protected readonly http = inject(HttpClient);

  findByParams(params: any): Observable<EntityArrayResponseType> {
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value === null || value === undefined || value === "") delete params[key];
    });
    return this.http.get<IProductList>(`${this.apiProduct}`, {observe: 'response', params});
  }

  findById(id: number): Observable<EntityResponseType> {
    return this.http.get<IProduct>(`${this.apiProduct}/${id}`, {observe: 'response', params: {completeSearch: false}});
  }

  delete(id: number): Observable<HttpResponse<{}>> {
    return this.http.delete(`${this.apiProduct}/${id}`, {observe: 'response'});
  }

  update(productFormData: FormData, id: number): Observable<HttpResponse<any>> {
    return this.http.put(`${this.apiProduct}/${id}`, productFormData, {observe: 'response'});
  }

  activate(activate: boolean, id: number): Observable<EntityResponseType> {
    return this.http.put<IProduct>(`${this.apiProduct}/activate/${id}`, {active: activate}, {observe: 'response'})
  }

  massiveLoad(file: File): Observable<HttpResponse<ProductMassiveLoadResponse>> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post<ProductMassiveLoadResponse>(
      `${this.apiProduct}/massive-load`,
      formData,
      {
        observe: 'response',
        context: new HttpContext().set(SHOW_TOAST, false)
      }
    );
  }

}
